import Footer from "../components/UI/Footer/Footer";
import Header from "../components/UI/Header/Header";
import Statistic from "../components/UI/Statistic/Statistic";

const StatisticPage = () => {

  return (
    <>
      <Header />
      <Statistic></Statistic>
      <Footer />
    </>
  );
};

export default StatisticPage;